<div class="flex flex-col w-full gap-5 h-full overflow-hidden">
  <proffeo-file-drop (filesAdded)="filesAdded.emit($event)" />
  <proffeo-file-horizontal-list
    (delete)="fileDelete.emit($event)"
    (avatarSet)="avatarSet.emit($event)"
    [files]="files()"
    [uploadingFiles]="activeUploads()"
    [canSetAsAvatar]="true"
    [avatarFileId]="task().avatarId"
  />
</div>
